import { render } from "./RFIHistoryPath.vue?vue&type=template&id=5b0829f7"
import script from "./RFIHistoryPath.vue?vue&type=script&lang=js"
export * from "./RFIHistoryPath.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__